(* generated by dune *)

(** @canonical Jsoo_runtime.Runtime_version *)
module Runtime_version = Jsoo_runtime__Runtime_version

module Jsoo_runtime__ = struct end
[@@deprecated "this module is shadowed"]
